import React, { useEffect } from 'react';
import { connect } from 'react-redux';

export const FontManager = connect((s: any) => {
  return {
    fonts: s.customFonts,
  };
})(({ fonts = [] }: any) => {
  useEffect(() => {
    if (!fonts.length) {
      return;
    }
    //

    if (window.FontFace) {
      fonts.map(family => {
        family.fonts.map(font => {
          const ff = new window.FontFace(family.name, `url(${font.url})`, {
            weight: font.weight,
            style: font.style,
          });
          ff.load().then(() => {
            document.fonts.add(ff);
          });
        });
      });
    }
  }, [fonts]);

  return null;
});
